/**
 * 팀 조회 관련 함수들
 * 
 * 이 파일은 모든 팀 쿼리 함수들을 재export하는 인덱스 파일입니다.
 * 실제 구현은 queries/ 디렉토리의 각 파일에 있습니다.
 */

// 팀 프로필 조회 관련
export {
  fetchTeamProfileByTeamManager,
  fetchTeamProfile,
  fetchTeamDetail,
  fetchTeamProfileWithMembers,
} from './queries/team-profile-queries'

// 내 팀 조회 관련
export { fetchMyTeams, fetchMyTeamsWithRole } from './queries/team-my-teams-queries'

// 팀 검색 관련
export { searchTeams } from './queries/team-search-queries'

// 팀 프로젝트 관련
export { fetchTeamProjects } from './queries/team-project-queries'

// 팀 안전성 검증 관련
export { checkTeamDeletionSafety } from './queries/team-safety-queries'
